import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useTenant } from "../hooks/useTenant";
import PageLoader from "../components/Common/PageLoader";

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const {
        idTenant,
        planId,
        tenantLifecycle,
        tenantName,
        user,
        loading: tenantLoading,
    } = useTenant();

    if (loading || (isAuthenticated && tenantLoading)) {
        return <PageLoader />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (tenantLifecycle?.blocked) {
        return (
            <Navigate
                to="/login"
                replace
                state={{
                    blockedTenant: {
                        tenantId: idTenant,
                        tenantName: tenantName || "Sua Empresa",
                        email: user?.email || "",
                        planId: planId || null,
                        billingStatus: tenantLifecycle.billingStatus || null,
                        blockReason: tenantLifecycle.reasonCode || "tenant_inactive",
                        blockMessage: tenantLifecycle.message || null,
                        trialStartDate: tenantLifecycle.trialStartDate || null,
                        trialEndsAt: tenantLifecycle.trialEndsAt || null,
                    },
                }}
            />
        );
    }

    return <>{children}</>;
};

export default ProtectedRoute;
